import React, { Component } from 'react';

import getMyMap, {createAreasMassLayer, createNamesLayer, createCommunesNamesLayerEasy, createCommuneMassLayer, createCommunesLayer, getLegendMode} from '../b-LeafletMap/leaflet_map';

import LegendCommune from '../b-LeafletMap/Legend/LegendCommune';
import LegendClusterArea from '../b-LeafletMap/Legend/LegendClusterArea';
import LegendValues from '../b-LeafletMap/Legend/LegendValues';
import Info from '../f-Utilities/Info';
import Sources from '../f-Utilities/Sources'

import {c_missing_data, c_gradient_reds_greens} from '../a-Graphic/Colors';

class Precariousness extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selected: "fuel",
      legend_label: "(part des ménages en précarité énergétique - %)"
    };

    this.colors = c_gradient_reds_greens.slice(2, 8).reverse()
  }

  displayCategory = (cat, legend_label) => {
      this.setState({
        selected: cat,
        legend_label: legend_label,
      })
  }

  getCommunes(){
    /* COMMUNES */
    var communes = this.props.territory.communes;

    var communes_coords = communes.map((c) => c.center);
    var communes_names = communes.map((c) => c.name);

    if(this.state.selected == "fuel"){
      var communes_nd = communes.filter((c) => c.precariousness.fuel == null)
      var communes_wd = communes.filter((c) => c.precariousness.fuel != null)
      var communes_masses = communes_wd.map((c) => c.precariousness.fuel);
      var communes_labels = communes_wd.map((c) => c.name + " - " + c.precariousness.fuel + " %");
      var mode = "fuel"
      var colors = this.colors
    }
    else if(this.state.selected == "fuel_housing"){
      var communes_nd = communes.filter((c) => c.precariousness.fuel_housing == null)
      var communes_wd = communes.filter((c) => c.precariousness.fuel_housing != null)
      var communes_masses = communes_wd.map((c) => c.precariousness.fuel_housing);
      var communes_labels = communes_wd.map((c) => c.name + " - " + c.precariousness.fuel_housing + " %");
      var mode = "fuel_housing"
      var colors = this.colors
    }
    return {communes_nd, communes_wd, communes_masses, communes_labels, mode, colors}
  }

  componentDidMount() {
    let {communes_nd, communes_wd, communes_masses, communes_labels, mode, colors} = this.getCommunes()

    // --- init map
    var mymap = this.mymap = getMyMap("precariousness", true, 0.3);

    // --- create layers
    var communes_layer = this.communes_layer = createCommuneMassLayer(mymap, communes_wd, communes_masses, communes_labels, mode, colors);
    var communes_layer_2 = this.communes_layer_2 = createCommunesLayer(mymap, communes_nd, null, c_missing_data);
    //var names_layer = this.names_layer = createNamesLayer(mymap, communes_coords, communes_names);
    createCommunesNamesLayerEasy(mymap, this.props.territory.communes)

    // ---update legend
    let legend = getLegendMode(mode, communes_masses, this.colors)
    this.setState({legend: legend})

    // --- center the map
    mymap.fitBounds(communes_layer.addLayer(communes_layer_2).getBounds());
  }

  componentDidUpdate(prevProps, prevState) {
    // --- update
    this.mymap.removeLayer(this.communes_layer);
    this.mymap.removeLayer(this.communes_layer_2);

    let {communes_nd, communes_wd, communes_masses, communes_labels, mode, colors} = this.getCommunes()

    // --- create layers;
    var communes_layer = this.communes_layer = createCommuneMassLayer(this.mymap, communes_wd, communes_masses, communes_labels, mode, colors);
    var communes_layer_2 = this.communes_layer_2 = createCommunesLayer(this.mymap, communes_nd, null, c_missing_data);

    // --- center the map
    this.mymap.fitBounds(communes_layer.addLayer(communes_layer_2).getBounds());
  }

  render() {
    let communes = this.props.territory.communes;
    let {communes_nd, communes_wd, communes_masses, communes_labels, mode, colors} = this.getCommunes()
    let missing_data = communes_nd.length > 0

    let [legend_intervals, legend_colors] = getLegendMode(mode, communes_masses, colors)

    return(
          <div className="row content mt-4 mb-5">

            <div className="col-3">
                <div className="row">
                  <div className="col-12">
                    <h3 className="mb-3">précarité énergétique</h3>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12 line-border">
                    <p
                    className={this.state.selected === "fuel" ?
                      "mb-2 mt-1 datalist selected" : "mb-2 mt-1 datalist"}
                    onClick={this.displayCategory.bind(this, "fuel", "(part des ménages en précarité énergétique - %)")}>précarité énergétique mobilité</p>
                    <p
                    className={this.state.selected === "fuel_housing" ?
                      "mb-2 mt-1 datalist selected" : "mb-2 mt-1 datalist"}
                    onClick={this.displayCategory.bind(this, "fuel_housing", "(part des ménages en précarité énergétique - %)")}>précarité énergétique mobilité ou logement</p>
                  </div>
                </div>


                <div className="row mt-5">
                  <div className="col-12">
                    <p className="mb-1">La précarité énergétique mobilité concerne <b>13.8%</b> des ménages en France,
                    c'est <b>20.3%</b> pour la précarité énergétique mobilité et logement.
                    <Info content="Les ménages en situation de précarité énergétique sont les ménages sous le 3ème décile de revenu, dont les dépenses énergétiques pour le logement ou pour le carburant de la mobilité quotidienne sont supérieures à un seuil (4,5% des revenus pour les dépenses de carburant, et 8% des revenus pour les dépenses énergétiques du logement)" /></p>
                  </div>
                </div>
            </div>

            <div className="col-9">
              <div className="row align-items-end">
                <div className="col-10">
                  <div style={{height: "500px"}} id="precariousness"></div>
                </div>
                <div className="col-2 pl-0 pr-0">
                     <LegendCommune label={this.state.legend_label}/>
                     <LegendValues intervals={legend_intervals}
                                   colors={legend_colors}
                                   missing_data={missing_data}/>
                </div>
              </div>
              <div className="row mt-1">
                <div className="col">
                 <Sources sources={this.props.territory.sources}
                        concerned={["precariousness"]}/>
                </div>
              </div>
            </div>

          </div>
    )
  }
}

export default Precariousness;
